import React from "react";
import { Coins } from "lucide-react";

const PricingSection = () => {
  return (
    <section className="py-24">
      <div className="container mx-auto px-4 max-w-3xl text-center">
        <div className="inline-flex p-3 rounded-xl bg-primary/10 mb-6">
          <Coins className="w-8 h-8 text-primary" />
        </div>
        <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-6">
          Credits & Pricing
        </h2>
        <p className="text-lg text-muted-foreground leading-relaxed">
          RemoteViz is free to join, and you'll start with{" "}
          <span className="text-foreground font-medium">100,000 free credits</span>. 
          After that, buy only the credits you plan to use — no subscriptions, 
          no auto-renewals, no surprises.
        </p>
      </div>
    </section>
  );
};

export default PricingSection;
